import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as AgencyService from 'services/iam/agency';

export const useAgencyService = () => {
  const { token } = useSelector((store) => store.user_data);

  const createAgency = async (options = {}) => {
    const { error, payload: agency } = await AgencyService.create({
      ...options,
      token
    });

    if (error) {
      toast.error('Cannot create agency at this time');
      return { agency: {} };
    }

    toast.success('Agency created successfully.');
    return { agency };
  };

  const fetchAgency = async (id, options = {}) => {
    const { error, payload } = await AgencyService.readById(id, { ...options, token });
    if (error) {
      return { agency: {}, error };
    }

    return { agency: payload, error: null };
  };

  const fetchAgencies = async (options = {}) => {
    const { error, payload } = await AgencyService.read({ ...options, token });
    if (error) {
      return { agencies: [], size: 0 };
    }

    const {
      data: agencies,
      meta: { size }
    } = payload;
    return { agencies, size };
  };

  const managePhoneVerification = async (step = 'initiation', options = {}) => {
    const { error, payload } = await AgencyService.managePhoneVerification(step, {
      ...options,
      token
    });

    return { error, payload };
  };

  const searchAgencies = async (keys, keyword, options = {}) => {
    const { error, payload } = await AgencyService.search(keys, keyword, { ...options, token });
    if (error) {
      return { agencies: [], size: 0 };
    }

    const {
      data: agencies,
      meta: { size }
    } = payload;
    return { agencies, size };
  };

  const updateAgency = async (id, options = {}) => {
    const { error, payload: agency } = await AgencyService.updateById(id, {
      ...options,
      token
    });

    if (error) {
      toast.error('Cannot update agency at this time');
      return { agency: {}, error };
    }

    toast.success('Agency updated successfully.');
    return { agency, error: null };
  };

  const verifyBusiness = async (options = {}) => {
    const { error, payload } = await AgencyService.verifyBusiness({ ...options, token });
    if (error) {
      toast.error(error);
      return { success: false };
    }

    toast.success('Business verified successfully.');
    return { success: true, details: payload };
  };

  const verifyBVN = async (options = {}) => {
    const { error, payload } = await AgencyService.verifyBVN({ ...options, token });
    if (error) {
      toast.error(error);
      return { success: false };
    }

    toast.success('BVN verified successfully.');
    return { success: true, details: payload };
  };

  const verifyNIN = async (options = {}) => {
    const { error, payload } = await AgencyService.verifyNIN({ ...options, token });
    if (error) {
      toast.error(error);
      return { success: false };
    }

    toast.success('NIN verified successfully.');
    return { success: true, details: payload };
  };

  return {
    createAgency,
    fetchAgency,
    fetchAgencies,
    managePhoneVerification,
    searchAgencies,
    updateAgency,
    verifyBusiness,
    verifyBVN,
    verifyNIN
  };
};
